import styled, { css } from 'styled-components';
import { variables } from '../theme/variables';
import { itemAsideBackgroundColor, itemTitleColor } from 'utils/theme';

export const OrderItemWrapper = styled.div`
  /* margin: 14px 0; */
  display: ${({ flex }) => (flex ? 'flex' : 'block')};
  padding: 21px 14px;
  border-radius: 12px;
  border-bottom: 1px solid rgba(189, 189, 189, 0.29);

  &:hover {
    background: ${itemAsideBackgroundColor};
  }

  .open-sans-bold {
    ${variables.fonts.openSansBold}
    color: ${itemTitleColor};
  }

  .open-sans-semibold {
    ${variables.fonts.openSansSemiBold}
  }

  a,
  button {
    color: inherit;
    ${variables.fonts.overpassMonoBold}
    display: block;
    text-decoration: underline;
  }

  button {
    border: none;
    background: transparent;
    padding: 0;
  }
`;

export const OrderItemCardMain = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
`;

export const CardRow = styled.div`
  margin-top: 14px;
  display: flex;
  justify-content: space-between;

  .text-right {
    text-align: right;
  }

  p {
    font-weight: 400;
  }
`;

export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : 'flex-start'};
  text-align: ${({ align }) => (align ? align : 'left')};
`;

export const MiddleItem = styled.div`
  margin: 14px 0;
`;

export const Group = styled.div`
  line-height: 1.4;
`;

export const Circle = styled.span`
  display: inline-block;
  background-color: #e4e4e4;
  border-radius: 8px;
  width: 64px;
  height: 64px;
  background-size: cover;
  margin-right: 28px;

  ${({ image }) =>
    image &&
    css`
      background-image: url(${image});
    `}

  @media only screen and (max-width: 767px) {
    margin: 0 auto;
  }
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 14px;

  input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
    transition: background 0.2s ease;
  }

  input[type='checkbox']:checked {
    background-color: #faea28;
    border-color: #faea28;
  }

  input[type='checkbox']:checked::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
